import { useParams } from 'react-router'

import Flex from '@/elements/Flex'
import Text from '@/elements/Text'
import useBreakpoints from '@/hooks/useBreakpoints'
import { useGetOrgUserInfo } from '@/api/user'
import IndividualNotificationsPreferences from '../IndividualNotificationsPreferences'

function IndividualNotifications() {
  const { id: individualIdParam } = useParams<{ id: string }>()
  const individualId = individualIdParam || ''

  const { isTablet, isMobile } = useBreakpoints()

  const { data: orgUserInfo } = useGetOrgUserInfo({ subjectId: individualId })
  const orgIndividualId = orgUserInfo?.data?.organizationIndividual?.id || ''

  if (!orgIndividualId) return null

  return (
    <Flex
      wfull
      gap={4}
      wrap
      className='card'
      inline={!isTablet}
      p={isMobile ? 3 : isTablet ? 5 : 7}
    >
      <Flex fraction={4} gap={2} wfull>
        <Text variant='h3'>Notifications</Text>
        <Text color='black-light-40'>
          Choose your settings for notifications for those that are available to you. If you don’t see settings you think you should see, talk to the manager of your account.
        </Text>
      </Flex>
      <IndividualNotificationsPreferences
        organizationIndividualId={orgIndividualId}
      />
    </Flex>
  )
}

export default IndividualNotifications
